import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import TableComponent from 'widgets/table/component';
import TypesRowsComponent from './TypesRowComponent';

const ReportContainer = (props) => {
  const { parentProperties } = props || {};
  const { redux } = parentProperties || {};
  const { iftReport } = redux || {};
  const [noDataOrdersByProduct, setNoDataOrdersByProduct] = useState(false);
  const [columnsProductTypes, setColumnsProductTypes] = useState([]);
  const [rowsProductType, setRowsProductType] = useState([]);

  useEffect(() => {
    generateDataColumnsProductTypes();
    return () => {};
  }, []);

  useEffect(() => {
    const rows = iftReport?.payload?.rows || [];

    if (rows.length === 0) {
      setNoDataOrdersByProduct(true);
      return;
    }

    setNoDataOrdersByProduct(false);
    const tableData = processTableData(rows);
    setRowsProductType(tableData);
  }, [iftReport]);

  const processTableData = (rows) => {
    return rows.map((item, index) => ({
      id: index,
      mx_month: item.mx_month,
      producto: item.product,
      sku: item.sku,
      q: item.quantity,
      minutes: item.minutes,
      minutes_altan: item.minutes_altan,
      minutes_roaming: item.minutes_roaming,
      total_min_con_altan: item.total_minutes_altan,
      sms: item.sms,
      sms_altan: item.sms_altan,
      sms_roaming: item.sms_roaming,
      total_sms: item.total_sms,
      total_sms_con_altan: item.total_sms_altan,
      mobile_data: item.mobile_data,
      mobile_data_roaming: item.mobile_data_roaming,
      total_mobile_data: item.total_mobile_data,
      social_network_data: item.social_network_data,
      social_network_data_roaming: item.social_network_data_roaming,
      social_network_data_throttling: item.social_network_data_throttling,
      throttling_data: item.throttling_data,
      total_mb_redes_sociales: item.total_megabites_social_network,
      total_gb_redes: item.total_gigabyte_social_network,
      total_datos_gb: item.total_gigabyte,
    }));
  };

  const generateDataColumnsProductTypes = () => {
    const columns = [
      { field: 'mx_month', headerName: 'Mes', width: 120 },
      { field: 'producto', headerName: 'Producto', width: 200 },
      { field: 'sku', headerName: 'SKU', width: 150 },
      { field: 'q', headerName: 'Cantidad', width: 100 },

      { field: 'minutes', headerName: 'Minutos', width: 120 },
      { field: 'minutes_altan', headerName: 'Minutos Altán', width: 130 },
      {
        field: 'minutes_roaming',
        headerName: 'Minutos Roaming',
        width: 140,
      },
      {
        field: 'total_min_con_altan',
        headerName: 'Total Minutos con Altán',
        width: 180,
      },

      { field: 'sms', headerName: 'SMS', width: 100 },
      { field: 'sms_altan', headerName: 'SMS Altán', width: 120 },
      { field: 'sms_roaming', headerName: 'SMS Roaming', width: 130 },
      { field: 'total_sms', headerName: 'Total SMS', width: 120 },
      {
        field: 'total_sms_con_altan',
        headerName: 'Total SMS con Altán',
        width: 180,
      },

      { field: 'mobile_data', headerName: 'Datos Móviles', width: 130 },
      {
        field: 'mobile_data_roaming',
        headerName: 'Datos Móviles Roaming',
        width: 180,
      },
      {
        field: 'total_mobile_data',
        headerName: 'Total Datos Móviles',
        width: 170,
      },

      {
        field: 'social_network_data',
        headerName: 'Datos Redes Sociales',
        width: 170,
      },
      {
        field: 'social_network_data_roaming',
        headerName: 'Datos Redes Sociales Roaming',
        width: 200,
      },
      {
        field: 'social_network_data_throttling',
        headerName: 'Datos Red. Soc. Throttling',
        width: 200,
      },
      {
        field: 'throttling_data',
        headerName: 'Datos Throttling',
        width: 150,
      },
      {
        field: 'total_mb_redes_sociales',
        headerName: 'Total MB Redes Sociales',
        width: 200,
      },
      {
        field: 'total_gb_redes',
        headerName: 'Total GB Redes Sociales',
        width: 200,
      },

      {
        field: 'total_datos_gb',
        headerName: 'Total Datos GB',
        width: 150,
      },
    ];

    setColumnsProductTypes(columns);
  };

  return (
    <Grid container spacing={5}>
      {iftReport.loaded === true && noDataOrdersByProduct === false ? (
        <Grid size={12}>
          <Grid container>
            <Grid size={{ xs: 12, md: 12 }}>
              <TableComponent
                columns={columnsProductTypes}
                rowsComponent={<TypesRowsComponent rows={rowsProductType} />}
                rawRows={rowsProductType}
              />
            </Grid>
          </Grid>
        </Grid>
      ) : noDataOrdersByProduct ? (
        <Grid size={12}>
          <h4>No hay datos para mostrar</h4>
        </Grid>
      ) : null}
    </Grid>
  );
};
export default ReportContainer;
